import React, { useState, useEffect, useRef } from 'react';
import { Client } from "@stomp/stompjs";
import SockJS from "sockjs-client";
import AppContext from '../../AppContext';
import { useNavigate } from 'react-router-dom';

const WebSocketWrapper = ({ children }) => {
    const [cart, setCart] = useState([]);
    const [orders, setOrders] = useState([]);
    const [products, setProducts] = useState([]);
    const [code, setCode] = useState(null);
    const [selectedItems, setSelectedItems] = useState([]);
    const clientRef = useRef(null);
    const baseUrl = process.env.REACT_APP_BACKEND_BASE_URL;
    const navigate = useNavigate();

    const setCookie = (name, value, hours) => {
        const d = new Date();
        d.setTime(d.getTime() + hours * 60 * 60 * 1000);
        const expires = "expires=" + d.toUTCString();
        document.cookie = name + "=" + value + ";" + expires + ";path=/";
    };

    const getCookie = (name) => {
        const cname = name + "=";
        const decodedCookie = decodeURIComponent(document.cookie);
        const ca = decodedCookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i].trim();
            if (c.indexOf(cname) === 0) {
                return c.substring(cname.length, c.length);
            }
        }
        return "";
    };

    useEffect(() => {
        const searchParams = new URLSearchParams(window.location.search);
        const queryCode = searchParams.get('code');
        const cookieCode = getCookie("code");

        if (!queryCode && !cookieCode) {
            navigate("/rescan");
            return;
        } else if (!queryCode && cookieCode) {
            setCode(cookieCode);
        } else if (queryCode) {
            setCookie("code", queryCode, 1);
            setCode(queryCode);
        }
    }, [navigate]);

    const initializeWebSocket = () => {
        if (!code) return;

        const socket = new SockJS(`${baseUrl}/ws`);
        const client = new Client({
            webSocketFactory: () => socket,
            reconnectDelay: 5000, // mechanizm wewnętrznego reconnecta
            heartbeatIncoming: 10000,
            heartbeatOutgoing: 10000,
            onConnect: () => {
                // Publikacja przy każdym (re)połączeniu
                client.publish({ destination: "/app/public/itemsToPay", body: `${code}` });
                client.publish({ destination: "/app/public/order", body: `${code}` });
                client.publish({ destination: "/app/public/menu", body: `${code}` });

                // Subskrypcje
                client.subscribe(`/topic/public/itemsToPay/${code}`, (message) => {
                    const updatedItems = JSON.parse(message.body);
                    setSelectedItems(prevItems => {
                        return updatedItems.map(updatedItem => {
                            const existingItem = prevItems.find(item => item.id === updatedItem.id);
                            if (existingItem) {
                                return {
                                    ...existingItem,
                                    quantity: updatedItem.quantity,
                                    quantityToPay: Math.min(existingItem.quantityToPay, updatedItem.quantity)
                                };
                            }
                            return updatedItem;
                        }).filter(item => updatedItems.some(updated => updated.id === item.id));
                    });
                });
                client.subscribe(`/topic/public/orderItems/${code}`, (message) =>
                    setOrders(JSON.parse(message.body))
                );
                client.subscribe(`/topic/public/menu/${code}`, (message) =>
                    setProducts(JSON.parse(message.body))
                );
            },
            onWebSocketClose: (evt) => {
                // Wymuszenie czyszczenia klienta
                clientRef.current = null;
                // Wymuszenie ponownej inicjalizacji po 5 sekundach
                setTimeout(() => {
                    initializeWebSocket();
                }, 5000);
            },
            onStompError: (frame) => {
            }
        });

        client.activate();
        clientRef.current = client;
    };

    useEffect(() => {
        if (code && !clientRef.current) {
            initializeWebSocket();
        }
    }, [code, baseUrl]);

    useEffect(() => {
        // Opcjonalnie: czyścimy klienta przy odmontowaniu komponentu
        return () => {
            if (clientRef.current) {
                clientRef.current.deactivate();
                clientRef.current = null;
            }
        };
    }, []);

    return (
        <AppContext.Provider value={{
            cart, setCart,
            orders, setOrders,
            products, setProducts,
            selectedItems, setSelectedItems, code, setCode
        }}>
            {children}
        </AppContext.Provider>
    );
};

export default WebSocketWrapper;